module.exports = __webpack_public_path__ + "img/success-green-check-mark-icon.0db3126c.svg";